var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36924 5.36924C3.21025 8.52823 3.21025 13.65 6.36924 16.809C9.29295 19.7327 13.9406 19.9713 17.1382 17.4098L20.4488 20.7204C21.2966 21.5682 22.5682 20.2966 21.7204 19.4488L18.4098 16.1382C20.9713 12.9406 20.7327 8.29295 17.809 5.36924C14.65 2.21025 9.52823 2.21025 6.36924 5.36924ZM7.64093 6.64087C10.0976 4.18417 14.0807 4.18417 16.5374 6.64087C18.9941 9.09757 18.9941 13.0807 16.5374 15.5374C14.0807 17.9941 10.0976 17.9941 7.64093 15.5374C5.18423 13.0807 5.18423 9.09757 7.64093 6.64087Z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5c0a3b0fe55cc6b84569d4d220c28557.svg";
export { ForwardRef as ReactComponent };